// Shared voxel builders for the base building prefab groups (buildings_*.ts):
// a solid `box()` and a shell-only `hollowBox()`.
import type { BlockVoxel } from './types.js';

export function box(
  sx: number,
  sy: number,
  sz: number,
  w: number,
  h: number,
  d: number,
  color: string,
  type?: string,
): BlockVoxel[] {
  const out: BlockVoxel[] = [];
  for (let x = sx; x < sx + w; x++)
    for (let y = sy; y < sy + h; y++)
      for (let z = sz; z < sz + d; z++) out.push({ x, y, z, color, ...(type ? { type } : {}) });
  return out;
}

export function hollowBox(
  sx: number,
  sy: number,
  sz: number,
  w: number,
  h: number,
  d: number,
  color: string,
  type?: string,
): BlockVoxel[] {
  const out: BlockVoxel[] = [];
  for (let x = sx; x < sx + w; x++)
    for (let y = sy; y < sy + h; y++)
      for (let z = sz; z < sz + d; z++)
        if (
          x === sx ||
          x === sx + w - 1 ||
          y === sy ||
          y === sy + h - 1 ||
          z === sz ||
          z === sz + d - 1
        )
          out.push({ x, y, z, color, ...(type ? { type } : {}) });
  return out;
}
